export default {"src":"/_next/static/media/IconMinus.47689835.svg","height":1,"width":11,"blurWidth":0,"blurHeight":0};